import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CartService } from 'src/app/_services/cart.service';
import { MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-view-clinic-product',
  templateUrl: './view-clinic-product.component.html',
  styleUrls: ['./view-clinic-product.component.scss']
})
export class ViewClinicProductComponent implements OnInit {
  data: any;
  loading: boolean = true;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private cartService: CartService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    // Simulate loading time for better UX
    setTimeout(() => {
      this.data = this.config.data;
      console.log('Product Details:', this.data);

      this.loadProductImage(this.data.image_url);
      
      // Initialize selectedQuantity if not present
      if (!this.data.selectedQuantity) {
        this.data.selectedQuantity = 1;
      }
      
      this.loading = false;
    }, 500); // 500ms loading delay
  }
  
  loadProductImage(imagePath: string): string {
    if (imagePath) {
      return `${environment.apiUrl}/${imagePath}`;
    } else {
      return 'assets/images/placeholder-image.png'; // Fallback image
    }
  }

  closeDialog() {
    this.ref.close();
  }

  increaseQuantity() {
    if (this.data.selectedQuantity < this.data.quantity) {
      this.data.selectedQuantity++;
    }
  }

  decreaseQuantity() {
    if (this.data.selectedQuantity > 1) {
      this.data.selectedQuantity--;
    }
  }

  getTotalCost(): number {
    return this.data?.cost_incl_vat * (this.data?.selectedQuantity || 1);
  }

  addProductToCart(product: any) {
    // Logic to add the product to the cart
    const totalPrice = product.cost_incl_vat * product.selectedQuantity;

    let cart: {
      price: number;
      description?: string;
      product_name?: string;
      selectedImage?: string;
      quantity: number;
      stock_item_code?: string;
      size?: string;
    } = {
      product_name: product.description,
      description: product.description,
      selectedImage: product.image_url,
      price: totalPrice,
      quantity: product.selectedQuantity,
      stock_item_code: product.stock_item_code,
      size: product.size
    }

    const savedProduct = localStorage.getItem('sendToCart');
    if (savedProduct != null) {
      const cartItems = JSON.parse(savedProduct);
      cartItems.push(cart);
      localStorage.setItem('sendToCart', JSON.stringify(cartItems));
      this.cartService.updateCartItems(cartItems);

      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Product added to cart successfully',
        key: 'main',
      });

    }else {
      const cartItems = [];
      cartItems.push(cart);
      localStorage.setItem('sendToCart', JSON.stringify(cartItems));
      this.cartService.updateCartItems(cartItems);

      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Product added to cart successfully',
        key: 'main',
      });
    }
  }
}
